import { render, staticRenderFns } from "./SelectOfAirports.vue?vue&type=template&id=54e7419c&scoped=true&"
import script from "./SelectOfAirports.vue?vue&type=script&lang=js&"
export * from "./SelectOfAirports.vue?vue&type=script&lang=js&"
import style0 from "./SelectOfAirports.vue?vue&type=style&index=0&id=54e7419c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e7419c",
  null
  
)

export default component.exports